export const toolbarsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_TOOLBARS':
            return { ...action.payload };
        default:
            return state;
    }
};
